import { startProxyAttendance } from '../../../../../db/classes';
import { useClassContext } from '../../../Context';
import { useAttendancePageContext } from '../Context';
import { addStartAttendanceDataToClass } from '../helpers';
import { AttendancePageScreens } from '../types';

const useAttendanceRecorded = () => {
  const { cls, setClass } = useClassContext();
  const { setCurrentScreen } = useAttendancePageContext();

  const numOfAttempts = cls?.attendance.numOfAttempts ?? 0;
  const numOfPresentStudents = cls?.attendance.markedInStudents ?? 0;

  const handleOnClickRetakeAttendance = async () => {
    if (!cls?.id) return;

    const response = await startProxyAttendance({ classId: cls?.id });

    setClass((prevClass) => {
      if (prevClass == null) return null;
      return addStartAttendanceDataToClass(prevClass, response);
    });

    setCurrentScreen(AttendancePageScreens.RECORDING_ATTENDANCE);
  };

  return { numOfAttempts, numOfPresentStudents, handleOnClickRetakeAttendance };
};

export default useAttendanceRecorded;
